import { jsx as _jsx } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';
import { useDrawer } from '../../AppDrawerContext';
export const CloseDrawerButton = (props) => {
    const { t } = useTranslation();
    const { closeDrawer } = useDrawer();
    return (_jsx(Tooltip, { title: t('button.close'), enterDelay: 400, arrow: true, children: _jsx(IconButton, { size: "medium", onClick: closeDrawer, ...props, children: _jsx(CloseIcon, {}) }) }));
};
